import Spinner from "../../Spinner";
import { useTableContext } from "./TableContext";

const TableLoader = () => {
    const { loading = false, loadingScreenReaderContent = '', loadingLabel } = useTableContext();

    if (!loading) return null;

    return (
        <div className='ted-ui-table-loading'>
            <Spinner size={"48"} isLoading={loading} label={loadingLabel} imageScreenReaderContent={loadingScreenReaderContent} />
        </div>
    )
}

export default TableLoader;